import Link from "next/link"

import Head from "../head-data/head-data"
import Heading from "../heading/heading"

import "./not-found.scss"

// A page whose content is missing or not visible to this visitor (an unknown
// slug, a draft, an unapproved question): the API returns null for both.
const NotFound = ({ title, body, href, linkText }) => (
  <div className="index">
    <div className="not-found">
      <Head title={`${title} | FounderCloud`} url={`https://www.foundercloud.com${href}`} noIndex />
      <Heading copy={title} element="h1" />
      <p>{body}</p>
      <Link href={href}>
        <a>{linkText}</a>
      </Link>
    </div>
  </div>
)

export default NotFound
